const layouts = {
  pink: {
    id: 'pink',
    name: 'Pink',
    primary: '#dd0055',
    primaryOffset: '#f8468a',
    mobileMenu: '#dd0055',
    antiGraph: '#8884d8',
    secondaryGraph: '#dd0055',
    background: '#fffcfc',
    background2: '#fffcfc',
    backgroundMobile: '#ddd',
    text: '#222',
    textSecondary: '#eee',
    textTransparent: '#22222280',
    border: '#aaa',
    borderTransparent: '#aaaaaa55',
    boxShadow: '#222',
    grey1: '#888',
    grey2: '#bbb',
    grey3: '#eae9e9',
    grey4: '#eae9e9',
    greyGraph: '#676767',
    scrollBack: '#888',
  },
  pinkDark: {
    id: 'pinkDark',
    name: 'Pink Dark',
    primary: '#dd0055',
    primaryOffset: '#be0049',
    mobileMenu: '#f5689e',
    antiGraph: '#8884d8',
    secondaryGraph: '#be0049',
    background: '#272424',
    background2: '#fcfcfc',
    backgroundMobile: '#333',
    text: '#efeee7',
    textSecondary: '#ddd',
    textTransparent: '#22222280',
    border: '#aaa',
    borderTransparent: '#aaaaaa55',
    boxShadow: '#222',
    grey1: '#888',
    grey2: '#777',
    grey3: '#333',
    grey4: '#363333',
    greyGraph: '#acacac',
    scrollBack: '#555',
  },
  pumpkin: {
    id: 'pumpkin',
    name: 'Pumpkin Dark',
    primary: '#e2773e',
    primaryOffset: '#d46e36',
    mobileMenu: '#f48042',
    antiGraph: '#50c25f',
    secondaryGraph: '#e2773e',
    background: '#262424',
    background2: '#fcfcfc',
    backgroundMobile: '#333',
    text: '#eee',
    textSecondary: '#ddd',
    textTransparent: '#22222280',
    border: '#aaa',
    borderTransparent: '#aaaaaa55',
    boxShadow: '#222',
    grey1: '#888',
    grey2: '#777',
    grey3: '#363333',
    grey4: '#363333',
    greyGraph: '#acacac',
    scrollBack: '#555',
  },
  evening: {
    id: 'evening',
    name: 'Evening Dark',
    primary: '#b92b27',
    primaryOffset: '#d84f4b',
    mobileMenu: '#d84f4b',
    antiGraph: '#1565C0',
    secondaryGraph: '#d84f4b',
    background: '#282424',
    background2: '#fcfcfc',
    backgroundMobile: '#333',
    text: '#eeeef8',
    textSecondary: '#ddd',
    textTransparent: '#22222280',
    border: '#aaa',
    borderTransparent: '#aaaaaa55',
    boxShadow: '#222',
    grey1: '#888',
    grey2: '#656565',
    grey3: '#363333',
    grey4: '#363333',
    greyGraph: '#acacac',
    scrollBack: '#555',
  },
  sky: {
    id: 'sky',
    name: 'Cool Sky',
    primary: '#2980B9',
    primaryOffset: '#46c0ec',
    mobileMenu: '#2980B9',
    antiGraph: '#646ad7',
    secondaryGraph: '#31aedb',
    background: '#fcfcfc',
    background2: '#fcfcfc',
    backgroundMobile: '#ddd',
    text: '#222',
    textSecondary: '#eee',
    textTransparent: '#22222280',
    border: '#aaa',
    borderTransparent: '#aaaaaa55',
    boxShadow: '#222',
    grey1: '#888',
    grey2: '#bbb',
    grey3: '#e7e7ec',
    grey4: '#e7e7ec',
    greyGraph: '#676767',
    scrollBack: '#777',
  },
  harvey: {
    id: 'harvey',
    name: 'Harvey',
    primary: '#2b574b',
    primaryOffset: '#69bd96',
    mobileMenu: '#386e60',
    antiGraph: '#0daeca',
    secondaryGraph: '#69bd96',
    background: '#fcfcfc',
    background2: '#fcfcfc',
    backgroundMobile: '#ddd',
    text: '#222',
    textSecondary: '#eee',
    textTransparent: '#dddddd60',
    border: '#aaa',
    borderTransparent: '#aaaaaa55',
    boxShadow: '#222',
    grey1: '#888',
    grey2: '#bbb',
    grey3: '#e7eae7',
    grey4: '#e7eae7',
    greyGraph: '#676767',
    scrollBack: '#5e5e5e',
  },
  spring: {
    id: 'spring',
    name: 'Spring',
    primary: '#0daf71',
    primaryOffset: '#70dd76',
    mobileMenu: '#0aaa71',
    antiGraph: '#0daecf',
    secondaryGraph: '#0daf71',
    background: '#fcfcfc',
    background2: '#fcfcfc',
    backgroundMobile: '#ddd',
    text: '#222',
    textSecondary: '#eee',
    textTransparent: '#77777790',
    border: '#aaa',
    borderTransparent: '#aaaaaa55',
    boxShadow: '#222',
    grey1: '#888',
    grey2: '#bbb',
    grey3: '#e7eae7',
    grey4: '#e7eae7',
    greyGraph: '#676767',
    scrollBack: '#acacac',
  },
  lime: {
    id: 'lime',
    name: 'Lime Dark',
    primary: '#80be46',
    primaryOffset: '#acbe56',
    mobileMenu: '#80be46',
    antiGraph: '#268074',
    secondaryGraph: '#acbe56',
    background: '#333',
    background2: '#fafafa',
    backgroundMobile: '#333',
    text: '#ccc',
    textSecondary: '#eee',
    textTransparent: '#ccc',
    border: '#aaa',
    borderTransparent: '#aaaaaa55',
    boxShadow: '#111',
    grey1: '#888',
    grey2: '#777',
    grey3: '#363333',
    grey4: '#666',
    greyGraph: '#676767',
    scrollBack: '#444',
  },
  vampire: {
    id: 'vampire',
    name: 'Vampire Dark',
    primary: '#86263b',
    primaryOffset: '#a31030',
    mobileMenu: '#a31030',
    antiGraph: '#46ac93',
    secondaryGraph: '#851b32',
    background: '#222',
    background2: '#fafafa',
    backgroundMobile: '#222',
    text: '#ddd',
    textSecondary: '#eee',
    textTransparent: '#ccccccbb',
    border: '#aaa',
    borderTransparent: '#aaaaaa55',
    boxShadow: '#111',
    grey1: '#888',
    grey2: '#777',
    grey3: '#363333',
    grey4: '#464646',
    greyGraph: '#777',
    scrollBack: '#555',
  },


}

export default layouts

// #851b32
// #0daf71
// #80be46


